import R from 'ramda';
import React from 'react';
import PropTypes from 'prop-types';

const isPartialStar = (index, rating) =>
  index > rating &&
  index - Math.floor(rating) < 2 &&
  !Number.isInteger(rating);

const getFirstDecimal = rating => rating.toFixed(1).substring(2);

export const getRatingImage = ({
  rating,
  index,
  imgOn,
  imgOff,
}) => {
  if (R.isNil(rating)) {
    return imgOff;
  }

  if (index <= rating) {
    return R.prop('fullStar', imgOn);
  } else if (isPartialStar(index, rating)) {
    const fractionalRating = getFirstDecimal(rating);

    switch (fractionalRating) {
      case '1':
        return R.prop('partialStar1', imgOn);
      case '2':
        return R.prop('partialStar2', imgOn);
      case '3':
        return R.prop('partialStar3', imgOn);
      case '4':
        return R.prop('partialStar4', imgOn);
      case '5':
        return R.prop('partialStar5', imgOn);
      case '6':
        return R.prop('partialStar6', imgOn);
      case '7':
        return R.prop('partialStar7', imgOn);
      case '8':
        return R.prop('partialStar8', imgOn);
      case '9':
        return R.prop('partialStar9', imgOn);
      default:
        return R.prop('fullStar', imgOn);
    }
  }
  return imgOff;
};

const ProductRating = ({
  averageRating,
  numberOfReviews,
  imgRatingOnSrc,
  imgRatingOffSrc,
  ratingIconWidth,
  ratingIconHeight,
}) => (
  <div className="product-rating flex-container align-center flex-dir-row">
    <div className="product-rating__stars flex-container align-center">
      {
        [...Array(5).keys()].map(index => (
          <img
            width={ratingIconWidth}
            height={ratingIconHeight}
            key={`star-${index + 1}`}
            src={getRatingImage({
              rating: averageRating,
              index: index + 1,
              imgOn: imgRatingOnSrc,
              imgOff: imgRatingOffSrc,
            })}
            alt=""
            className="product-rating__star"
            aria-hidden
          />
        ))
      }
    </div>
    {numberOfReviews > 0 &&
      <p className="product-rating__review-number">{numberOfReviews}</p>
    }
  </div>
);

ProductRating.propTypes = {
  averageRating: PropTypes.number,
  numberOfReviews: PropTypes.number,
  imgRatingOnSrc: PropTypes.shape({
    fullStar: PropTypes.string,
    partialStar1: PropTypes.string,
    partialStar2: PropTypes.string,
    partialStar3: PropTypes.string,
    partialStar4: PropTypes.string,
    partialStar5: PropTypes.string,
    partialStar6: PropTypes.string,
    partialStar7: PropTypes.string,
    partialStar8: PropTypes.string,
    partialStar9: PropTypes.string,
  }).isRequired,
  imgRatingOffSrc: PropTypes.string,
  ratingIconWidth: PropTypes.number,
  ratingIconHeight: PropTypes.number,
};

export default ProductRating;
